import React, { useRef, useState } from "react";
import { SampleNextArrow, SamplePrevArrow } from "../../shared/Arrow";
import Button from "../../shared/Button";
import Slider from "react-slick";
import moment from 'jalali-moment'
import useFetch from "../../../hooks/useAxios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

const NewsCard = ({ avatar, name, date, img, title }) => {
  
  return (
    <div className="NewsCard  text-right flex flex-col items-start">
      <div className="flex">
        <div className="  mr-[10px]">
          <p className="font-[500] text-[#292D32] text-[20px]">{name}</p>
          <p className="font-[400] text-[#797D82] text-[17px] ltr">منتشر شده در {date} </p>
        </div>
        <img src={avatar}  />
      </div>
      <img src={img} className='my-[20px]'/>
      <h3 className="font-[700] text-[#292D32] text-[24px]">
        {title}
      </h3>
    </div>
  );
};

const Newscarousel = () => {
  const slider1 = useRef();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
        
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
        
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
    ]
  };
  const next = () => {
    slider1.current.slickNext();
  };
  const previous = () => {
    slider1.current.slickPrev();
  };
  const [infoHome, setinfoHome] = useState([]) 

  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/posts",
    noHeader: true,
    trigger: true,
    argFunc:(res)=>{setinfoHome(res.data.posts);}
   
  });
  const navigate = useNavigate()
  return (
    <div className="container">
      <div className=" flex justify-between items-center mt-[100px]">
        <div className="title--home">
          <h4 className="font-[700] text-[40px] text-[#292D32]">مجله جاتیک</h4>
          <div className="text-[20px] mt-[10px] text-[#797D82] title--home--p">
            بهترین اقامتگاه ها را با مناسب ترین قیمت ها و امکانات رزرو کنید
          </div>
        </div>
        <div className="flex">
          <Button varient="primary" className="ml-[40px]" onClick={()=>navigate("/blog")}>
            مشاهده بیشتر
          </Button>
          <SampleNextArrow onClick={next} />
          <SamplePrevArrow onClick={previous} />
        </div>
      </div>
      <div className="mt-[40px] Newscarousel">
      {!apiGetHomeInfo.loading ?   <Slider ref={slider => (slider1.current = slider)} {...settings}>
        {infoHome.map(i=> <NewsCard
            avatar={i.author.avatar}
            name={i.author.full_name}
            date={i.created_at}
           img={i.thumbnail.path}
            title={i.title}
          />) }
       
        </Slider> :
          <div >
          <SkeletonTheme height={400} borderRadius={10}>
            <div className="grid grid-cols-4 gap-[20px]">
              <Skeleton />
              <Skeleton />
              <Skeleton />
              <Skeleton />
            
            </div>
          </SkeletonTheme>
        </div>}
      </div>
    </div>
  );
};

export default Newscarousel;
